__webpack_require__.p = "https://testportal.b-alert.com/sleep-profiler/";